
<template>
  <vue-final-modal
    v-slot="{ close }"
    :classes="
      'modal-container ' + (dockPosition ? 'docked ' : '') + classDetail
    "
    content-class="modal-content "
    v-bind="$attrs"
    :esc-to-close="true"
    :drag="isDrag"
    :resize="resize"
    :content-style="styles"
    :click-to-close="false"
    drag-selector=".modal__title"
    class="ms-dynamic-popup"
    :transition="{
      'enter-active-class': '.3s cubic-bezier(.25,.8,.25,1)',
      'enter-class': 'translate-y-full',
      'enter-to-class': 'translate-y-0',
      'leave-active-class': 'transition duration-200 ease-in-out transform',
      'leave-to-class': 'translate-y-full',
      'leave-class': 'translate-y-0',
    }"
  >
    <div
      class="modal__title"
      :class="[{ modal__drag: isDrag }, classTitle]"
    >
      <span
        class="title"
        @click="redirectClick"
      >{{ title }}</span>
      <slot name="content-title" />
    </div>
    <div class="close-icon">
      <slot name="icon" />
      <div
        v-if="maximumable"
        class="button icon24"
        :class="['button', maximum ? 'restore' : 'maximum']"
        @click="maximumClick"
      />
      <div
        v-if="showClose"
        v-tooltip="'Đóng'"
        class="modal__close button icon24 close"
        @click="close"
      />
    </div>
    <div class="modal__content flex-column flex1">
      <span
        v-shortkey="defaultShortKey"
        class="popup-shortkey"
        @shortkey="shortkeyAction"
      />
      <slot
        name="content"
        :close="close"
      />
    </div>
    <div
      v-if="$slots['footer']"
      class="modal__footer"
    >
      <slot
        name="footer"
        :close="close"
      />
    </div>
  </vue-final-modal>
</template>

<script>
import { shortkeyStatusbar } from '@/mixins/common/shortkeyStatusbar'
export default {
  name: 'MsDynamicPopup',
  mixins: [shortkeyStatusbar],
}
</script>
<script setup>
/* eslint-disable import/first */
import {
  defineProps,
  computed,
  getCurrentInstance,
  watchEffect,
  onMounted,
  onUnmounted,
} from 'vue'

const { proxy } = getCurrentInstance()
const emit = defineEmits(['shortkeyAction', 'redirectClick'])
const props = defineProps({
  dragable: {
    type: Boolean,
    default: true,
  },
  resize: {
    type: Boolean,
    default: false,
  },
  width: {
    type: Number,
    default: 0,
  },
  height: {
    type: Number,
    default: 0,
  },
  title: {
    type: String,
    default: '',
  },
  maximum: {
    type: Boolean,
    default: false,
  },
  /**
   * Có hiển thị icon maxixum không
   */
  maximumable: {
    type: Boolean,
    default: false,
  },
  params: {
    type: Object,
    default: () => {},
  },
  classTitle: {
    type: String,
    default: '',
  },
  dockPosition: {
    type: String,
    default: null,
  },

  /**
   * Định nghĩa shortKey
   */
  shortkey: {
    default: null,
    type: [String, Object],
  },

  /**
   * class root
   */
  classDetail: {
    default: null,
    type: String,
  },
  /**
   * có show button close không
   */
  showClose: {
    type: Boolean,
    default: true,
  },
})

const defaultShortKey = Object.assign(
  {
    Close: ['esc'], // Đóng
    Save: ['ctrl', 's'], // Cất
    SaveAndAdd: ['ctrl', 'shift', 's'], // Cất và thêm
    Help: ['f1'], // Giúp
    Print: ['ctrl', 'p'], // IN
    Maximum: ['ctrl', 'space'], // phóng to thu nhỏ form
    QuickSelect: ['f3'], // chọn nhanh
    ArrowLeft: ['arrowleft'],
    ArrowRight: ['arrowright'],
    Postpone: ['ctrl', 'u'], // hoãn
    Edit: ['ctrl', 'e'], // sửa
    Refresh: ['ctrl', 'r'], // load lại grid
    Delete: ['ctrl', 'd'], // xóa
    Duplicate: ['ctrl', 'c'], // nhân bản
    Posted: ['ctrl', 'g'], // Ghi sổ
  },
  props.shortkey
)

const isDrag = computed(() => {
  if (props.maximum) return false

  if (props.dockPosition) return false
  return props.dragable !== false
})

const styles = computed(() => {
  const style = {}
  if (props.width) {
    props.width < screen.width - 48
      ? style.width = `${props.width}px`
      : style.width = `${screen.width - 48}px`
  }

  if (props.height) style.height = `${props.height}px`

  if (props.maximum) {
    style.width = '100%'
    style.height = '100vh'
    style.top = 0
    style.left = 0
  }

  if (props.dockPosition) {
    style.height = '100vh'
    switch (props.dockPosition) {
      case 'left':
        style.left = 0
        break
      case 'right':
        style.right = 0
        break
    }
  }
  return style
})

/**
 * Push el để xử lý shortkey cho view
 */
onMounted(() => {
  proxy.$ms.commonFn.shortkeyPushView(proxy.$el)
})

/**
 * Loại bỏ el dùng cho shortkey
 */
onUnmounted(() => {
  proxy.$ms.commonFn.shortkeyPopView(proxy.$el)
})
/**
 * emit event click title
 * bnanh 01.07.2022
 */
const redirectClick = () => {
  emit('redirectClick')
}

const maximumClick = () => {
  proxy.$emit('update:maximum', !props.maximum)
}

/**
 * emit event phím tắt
 */
const shortkeyAction = (e) => {
  const me = this
  switch (e.srcKey) {
    default:
      emit('shortkeyAction', e)
      break
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/function.scss';

:deep(.modal-container) {
  display: flex;
  justify-content: center;
  align-items: center;
  &.docked {
    justify-content: unset;
  }
}
:deep(.modal-content) {
  position: absolute;
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  background: #fff;
}
.modal__content {
  flex: 1;
  padding: 0 24px;
}
.modal__title {
  padding: 24px 52px;
  display: flex;
  justify-content: center;
  &:hover {
    cursor: move;
  }
  .title {
    @include head(h3);
    color: $color-text;
  }
  .button {
    cursor: pointer;
    display: inline-block;
    padding: 10px 8px;
  }

  .title-right {
    display: flex;
    align-items: center;
  }
}
.close-icon {
  position: absolute;
  top: 12px;
  right: 24px;
  cursor: pointer;
}
.modal__footer {
  height: fit-content;
  padding: 24px;
  display: flex;
}
.modal__close {
  position: absolute;
  top: 1rem;
  right: 1rem;
}
</style>
